export const COLORS = {
  green: '#16584A',
  teal: '#12908D',
  lime: '#B7F14B',
  orange: '#FFA825',
  yellow: '#FFD84B',
  purple: '#7C53FF',
};

const colors = Object.values(COLORS);

function hashString(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash &= hash; // Convert to 32-bit integer
  }
  return Math.abs(hash);
}

export function colorForTag(str) {
  const hash = hashString(str);
  return colors[hash % colors.length];
}

export default colors;
